import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-tpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationService } from "../../../view-application.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsTpamsConstants } from "./view-application-details-tpams.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { TownplanningService } from "../../../../../shared/services/modules/townplanning.service";
import { mapTpApplicationTypeLimitToUiState, normalizeTpApplicationTypeLimit } from "../../../../../shared/utils/tp-application-type-limit.utils";
let ViewApplicationDetailsTpamsComponent = class ViewApplicationDetailsTpamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    townplanningService;
    viewApplicationService;
    route;
    routerParamsService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsTpamsConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = ViewApplicationDetailsTpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = ViewApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    zonesFormControlName = ViewApplicationDetailsTpamsConstants.ZONES_FORM_CONTROL_NAME;
    zoneFormControlName = ViewApplicationDetailsTpamsConstants.ZONE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsTpamsConstants.REFERENCE_NUMBER_CONTROL_NAME;
    previousReferenceNumberFormControlName = ViewApplicationDetailsTpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = ViewApplicationDetailsTpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    addApplicationTypeLabel = ViewApplicationDetailsTpamsConstants.ADD_APPLICATION_TYPE_LABEL;
    addZoneLabel = ViewApplicationDetailsTpamsConstants.ADD_ZONE_LABEL;
    referenceNumberLabel = ViewApplicationDetailsTpamsConstants.REFERENCE_NUMBER_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPE_LABEL;
    zoneLabel = ViewApplicationDetailsTpamsConstants.ZONE_LABEL;
    descriptionLabel = ViewApplicationDetailsTpamsConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = ViewApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    previousReferenceNumberLabel = ViewApplicationDetailsTpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = ViewApplicationDetailsTpamsConstants.IS_RESUBMISSION_LABEL;
    applicationTypes = [];
    zones = [];
    saveBtnPlaceholder = ViewApplicationDetailsTpamsConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    rezoneConfirmationControlName = ViewApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME;
    rezoneConfirmationLabel = ViewApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_LABEL;
    rezoneKeywordRezone = ViewApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONE;
    rezoneKeywordRezoning = ViewApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONING;
    isRezoning = false;
    rezoningChecked = false;
    applicationTypesControl;
    applicationTypeLimit = ViewApplicationDetailsTpamsConstants.UNLIMITED_APPLICATION_TYPE_LIMIT;
    applicationTypeLimitReachedWarningMessage = ViewApplicationDetailsTpamsConstants.APPLICATION_TYPE_LIMIT_REACHED_WARNING_MESSAGE;
    applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, 0);
    supportResubmissions = false;
    isResubmission = false;
    getApplicationSaveObservableSubscription;
    getApplicationSetZonesObservableSubscription;
    getApplicationSetApplicationTypesObservableSubscription;
    constructor(aflaModuleStrategyService, townplanningService, viewApplicationService, route, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.townplanningService = townplanningService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.loadApplicationTypeLimit();
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            this.zones = this.aflaModuleStrategyService.lookups.get("zones");
            this.getApplication();
        }
        else {
            this.getLookups();
        }
    }
    getApplication() {
        const params = {
            $expand: `applicationTypes,applicationZonings`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe((response) => {
            if (this.appController.moduleAllowResubmission) {
                this.supportResubmissions = true;
            }
            this.onGetApplicationCompleted(response);
        }, (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    getApplicationTypes() {
        return this.detailsForm.get("applicationTypes");
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
    }
    getZones() {
        return this.detailsForm.get("zones");
    }
    onBtnRemoveZoneClicked(i) {
        const zoneControls = this.getZones();
        if (zoneControls.controls.length > 1) {
            zoneControls.removeAt(i);
        }
    }
    onBtnAddApplicationTypeClicked() {
        if (this.isApplicationTypeAddBlockedByLimit()) {
            return;
        }
        if (!this.canAddSelectionControl(this.getApplicationTypes(), this.applicationTypeFormControlName, this.applicationTypes, ViewApplicationDetailsTpamsConstants.ALL_APPLICATION_TYPES_ADDED_WARNING_MESSAGE)) {
            return;
        }
        this.addApplicationTypeControl();
        this.updateApplicationTypeLimitUiState();
    }
    shouldShowAddApplicationTypeButton() {
        return !this.applicationTypeLimitUiState.hideButtons && !this.applicationTypeLimitUiState.disableAdd;
    }
    onBtnAddZoneClicked() {
        if (!this.canAddSelectionControl(this.getZones(), this.zoneFormControlName, this.zones, ViewApplicationDetailsTpamsConstants.ALL_ZONES_ADDED_WARNING_MESSAGE)) {
            return;
        }
        this.addZoneControl();
    }
    onBtnSaveClicked($event) {
        if (this.detailsForm.valid) {
            const app = {
                amendmentSchemeNumber: this.detailsForm.get(this.amendmentSchemeNumberFormControlName).value,
                isResubmission: this.detailsForm.get(this.isResubmissionFormControlName).value,
                previousReferenceNumber: this.detailsForm.get(this.previousReferenceNumberFormControlName).value,
            };
            const zoneParams = {
                zones: []
            };
            const zoneControls = this.getZones();
            zoneControls.controls.forEach(zoneControl => {
                const zone = {
                    id: zoneControl.get("id").value,
                    applicationId: zoneControl.get("applicationId").value,
                    applicationPropertyId: zoneControl.get("applicationPropertyId").value,
                    zoning: zoneControl.get("zone").value.value,
                    deleted: false,
                };
                zoneParams.zones.push(zone);
            });
            const typeParams = {
                types: []
            };
            const typeControls = this.getApplicationTypes();
            typeControls.controls.forEach(typeControl => {
                const type = {
                    id: typeControl.get("id").value,
                    applicationId: typeControl.get("applicationId").value,
                    applicationType: typeControl.get("type").value.value,
                    deleted: false
                };
                typeParams.types.push(type);
            });
            this.getApplicationSaveObservableSubscription =
                this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, app)
                    .subscribe(appSaveresponse => {
                    this.setZones(zoneParams, typeParams);
                }, error => {
                    this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Update);
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.amendmentSchemeNumberFormControlName).setValue(application.amendmentSchemeNumber);
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(this.application.isResubmission);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(this.application.previousReferenceNumber);
            if (this.application.isResubmission) {
                this.isResubmission = this.application.isResubmission;
            }
            this.detailsForm.get("isResubmission").disable();
            this.detailsForm.get("previousReferenceNumber").disable();
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            const typesControl = this.getApplicationTypes();
            typesControl.clear();
            const persistedApplicationTypes = this.getPersistedApplicationTypes(application.applicationTypes);
            persistedApplicationTypes.forEach(applicationType => {
                const appType = this.findApplicationTypeLookupOption(applicationType.applicationType);
                const typeGroup = new FormGroup({
                    id: new FormControl(applicationType.id),
                    applicationId: new FormControl(applicationType.applicationId),
                    type: new FormControl(appType, [Validators.required])
                });
                typesControl.push(typeGroup);
            });
            this.updateApplicationTypeLimitUiState();
            const zonesControl = this.getZones();
            zonesControl.clear();
            application.applicationZonings.forEach(applicationZoning => {
                let zone = null;
                this.zones.forEach(item => {
                    if (item.value === applicationZoning.zoning) {
                        zone = item;
                    }
                });
                const zoneGroup = new FormGroup({
                    id: new FormControl(applicationZoning.id),
                    applicationId: new FormControl(applicationZoning.applicationId),
                    applicationPropertyId: new FormControl(applicationZoning.applicationPropertyId),
                    zone: new FormControl(zone, [Validators.required])
                });
                zonesControl.push(zoneGroup);
            });
            this.syncRezoningStateWithSelection();
        }
        this.changeDetectorRefs.detectChanges();
    }
    getLookups() {
        // this.requestStatusService.showBusySpinner("gettingLookups");
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'ApplicationType' or name eq 'Zoning')`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.aflaModuleStrategyService.lookups.set("zones", zones);
        this.zones = zones;
        this.getApplication();
    }
    setZones(zoneParams, typeParams) {
        this.getApplicationSetZonesObservableSubscription =
            this.townplanningService.getApplicationSetZonesObservable(this.application.id, zoneParams)
                .subscribe(addZoneesponse => {
                this.setTypes(typeParams);
            }, error => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Update);
            });
    }
    setTypes(typeParams) {
        this.getApplicationSetApplicationTypesObservableSubscription =
            this.townplanningService.getApplicationSetApplicationTypesObservable(this.application.id, typeParams)
                .subscribe(addTypesResponse => {
                this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
            }, error => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Update);
            });
    }
    onApplicationTypeSelected(index) {
        const duplicateSelectionFound = this.clearControlSelectionIfDuplicate(this.getApplicationTypes(), this.applicationTypeFormControlName, index, ViewApplicationDetailsTpamsConstants.DUPLICATE_APPLICATION_TYPE_WARNING_MESSAGE);
        if (duplicateSelectionFound) {
            this.updateApplicationTypeLimitUiState();
            this.syncRezoningStateWithSelection();
            return;
        }
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
    }
    onZoneSelected(index) {
        this.clearControlSelectionIfDuplicate(this.getZones(), this.zoneFormControlName, index, ViewApplicationDetailsTpamsConstants.DUPLICATE_ZONE_WARNING_MESSAGE);
    }
    onRezoningChecked(event) {
        const element = event.target.checked;
        this.rezoningChecked = element;
        const zonesControl = this.getZones();
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.addZoneControl();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.clear();
        zonesControl.disable();
    }
    addApplicationTypeControl() {
        const typeGroup = new FormGroup({
            id: new FormControl(0),
            applicationId: new FormControl(0),
            type: new FormControl(null, [Validators.required])
        });
        this.getApplicationTypes().push(typeGroup);
    }
    addZoneControl() {
        const zoneGroup = new FormGroup({
            id: new FormControl(0),
            applicationId: new FormControl(0),
            applicationPropertyId: new FormControl(0),
            zone: new FormControl(null, [Validators.required])
        });
        this.getZones().push(zoneGroup);
    }
    canAddSelectionControl(controls, controlName, availableOptions, warningMessage) {
        const selectedValues = this.getDistinctSelectedValues(controls, controlName);
        const allOptionsAlreadySelected = availableOptions.length > 0 && selectedValues.size >= availableOptions.length;
        if (allOptionsAlreadySelected) {
            this.appController.showMessage(warningMessage, AlertType.Warning);
            return false;
        }
        return true;
    }
    getDistinctSelectedValues(controls, controlName) {
        const selectedValues = new Set();
        controls.controls.forEach(control => {
            const selectedOption = control.get(controlName)?.value;
            if (selectedOption?.value) {
                selectedValues.add(selectedOption.value.toLowerCase());
            }
        });
        return selectedValues;
    }
    clearControlSelectionIfDuplicate(controls, controlName, selectedIndex, warningMessage) {
        const selectedControl = controls.at(selectedIndex);
        const selectedOption = selectedControl.get(controlName)?.value;
        if (!selectedOption?.value) {
            return false;
        }
        const selectedValue = selectedOption.value.toLowerCase();
        const duplicateSelectionExists = controls.controls.some((control, index) => {
            if (index === selectedIndex) {
                return false;
            }
            const currentValue = control.get(controlName)?.value?.value;
            return currentValue?.toLowerCase() === selectedValue;
        });
        if (!duplicateSelectionExists) {
            return false;
        }
        selectedControl.get(controlName).setValue(null);
        this.appController.showMessage(warningMessage, AlertType.Warning);
        return true;
    }
    syncRezoningStateWithSelection() {
        this.isRezoning = this.hasSelectedRezoningApplicationType();
        const zonesControl = this.getZones();
        if (!this.isRezoning) {
            this.rezoningChecked = false;
            zonesControl.clear();
            zonesControl.disable();
            return;
        }
        const hasSelectedZoneValue = this.hasSelectedZoneValue();
        const hasVisibleZoneRows = zonesControl.length > 0 && zonesControl.enabled;
        this.rezoningChecked = hasSelectedZoneValue || hasVisibleZoneRows;
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.addZoneControl();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.clear();
        zonesControl.disable();
    }
    hasSelectedRezoningApplicationType() {
        const applicationTypeControls = this.getApplicationTypes();
        return applicationTypeControls.controls.some(control => {
            const selectedType = control.get(this.applicationTypeFormControlName)?.value;
            return this.isRezoningApplicationType(selectedType);
        });
    }
    isRezoningApplicationType(applicationType) {
        if (!applicationType?.value) {
            return false;
        }
        const typeValue = applicationType.value.toLowerCase();
        return typeValue.includes(this.rezoneKeywordRezone) || typeValue.includes(this.rezoneKeywordRezoning);
    }
    hasSelectedZoneValue() {
        const zonesControl = this.getZones();
        return zonesControl.controls.some(control => {
            const selectedZone = control.get(this.zoneFormControlName)?.value;
            return !!selectedZone?.value;
        });
    }
    loadApplicationTypeLimit() {
        const moduleId = this.getCurrentModuleIdForLimit();
        this.townplanningService.getApplicationTypeLimitObservable(moduleId).subscribe((applicationTypeLimit) => {
            this.applicationTypeLimit = normalizeTpApplicationTypeLimit(applicationTypeLimit);
            this.updateApplicationTypeLimitUiState();
            this.changeDetectorRefs.detectChanges();
        });
    }
    isApplicationTypeAddBlockedByLimit() {
        this.updateApplicationTypeLimitUiState();
        if (!this.applicationTypeLimitUiState.disableAdd) {
            return false;
        }
        this.appController.showMessage(this.applicationTypeLimitReachedWarningMessage, AlertType.Warning);
        return true;
    }
    ensureApplicationTypeDropdownIsVisible() {
        const applicationTypeControls = this.getApplicationTypes();
        if (applicationTypeControls.length > 0) {
            return;
        }
        this.addApplicationTypeControl();
    }
    updateApplicationTypeLimitUiState() {
        if (!this.detailsForm) {
            return;
        }
        const currentVisibleControlCount = this.getApplicationTypeControlCountForLimit();
        this.applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, currentVisibleControlCount);
        if (this.applicationTypeLimitUiState.fullWidthDropdown) {
            this.ensureApplicationTypeDropdownIsVisible();
        }
    }
    getCurrentModuleIdForLimit() {
        const routeModuleId = Number(this.moduleID);
        if (Number.isFinite(routeModuleId) && routeModuleId > 0) {
            return routeModuleId;
        }
        const selectedModuleId = Number(this.appController.selectedModuleID);
        if (Number.isFinite(selectedModuleId) && selectedModuleId > 0) {
            return selectedModuleId;
        }
        return 0;
    }
    getApplicationTypeControlCountForLimit() {
        return this.getApplicationTypes().length;
    }
    getPersistedApplicationTypes(applicationTypes) {
        if (!Array.isArray(applicationTypes) || applicationTypes.length === 0) {
            return [];
        }
        return applicationTypes.filter((applicationType) => this.hasNonEmptyText(applicationType?.applicationType));
    }
    findApplicationTypeLookupOption(applicationTypeValue) {
        const matchingLookup = this.applicationTypes.find((lookupItem) => lookupItem.value === applicationTypeValue);
        return matchingLookup ?? null;
    }
    hasNonEmptyText(value) {
        if (typeof value !== "string") {
            return false;
        }
        return value.trim().length > 0;
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: TownplanningService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsTpamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-tpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsTpamsComponent);
export { ViewApplicationDetailsTpamsComponent };
